const LockOpenIcon = (props) => {
    return <i className={"fa-solid fa-lock-open " + props.className}></i>
}

export default LockOpenIcon;